import React from "react";
import Services from "./Services";
import { BrowserRouter } from "react-router-dom";
import Navbar from "../components/Navbar";
import About from "./About";
import ImageGallery from "./ImageGallery";
import Footer from "./Footer";
import construction0 from "../assets/construction0.png";
import construction1 from "../assets/construction1.png";
import construction2 from "../assets/construction2.png";
import construction3 from "../assets/construction3.png";
import construction4 from "../assets/construction4.png";
import construction5 from "../assets/construction5.png";
import maisonJaune from "../assets/maisonJaune.png";
import maisonBlanche from "../assets/maisonBlanche.png";
import maisonBrun from "../assets/maisonBrun.png";
import maisonCreme from "../assets/maisonCreme.png";
import maisonCremeFace from "../assets/maisonCremeFace.jpeg";
import maisonCremeProfil from "../assets/maisonCremeProfil.jpeg";
import maisonBlancheFace from "../assets/maisonBlancheFace.jpeg";
import maisonBlancheProfil from "../assets/maisonBlancheProfil.jpeg";
import maisonGrisToit from "../assets/maisonGrisToit.jpg";
import maisonGrisToit2 from "../assets/maisonGrisToit2.jpg";
import maisonGrisToit3 from "../assets/maisonGrisToit3.jpg";
import maisonGrisFinie from "../assets/maisonGrisFinie.jpg";
import maisonBlancheGris from "../assets/maisonBlancheGris.jpg";
import GoogleMapsAddress from "../components/GoogleMapsAddress";
import ContactForm from "./ContactForm";

const Home = () => {
  const images = [
    {
      src: construction0,
      alt: "construction 0",
      title: "Image 1",
      description: "Description de l'image 1",
    },
    {
      src: construction1,
      alt: "construction 1",
      title: "Image 2",
      description: "Description de l'image 2",
    },
    {
      src: construction2,
      alt: "construction 2",
      title: "Image 3",
      description: "Description de l'image 3",
    },
    {
      src: construction3,
      alt: "construction 3",
      title: "Image 4",
      description: "Description de l'image 3",
    },
    {
      src: construction4,
      alt: "construction 4",
      title: "Image 5",
      description: "Description de l'image 3",
    },
    {
      src: construction5,
      alt: "construction 5",
      title: "Image 6",
      description: "Description de l'image 3",
    },
    {
      src: maisonJaune,
      alt: "maison Jaune",
      title: "Image 7",
      description: "Description de l'image 3",
    },
    {
      src: maisonBlanche,
      alt: "maison Blanche",
      title: "Image 8",
      description: "Description de l'image 3",
    },
    {
      src: maisonBrun,
      alt: "maison Brun",
      title: "Image 9",
      description: "Description de l'image 3",
    },
    {
      src: maisonCreme,
      alt: "maison Creme",
      title: "Image 10",
      description: "Description de l'image 3",
    },
    {
      src: maisonCremeFace,
      alt: "maison Creme Face",
      title: "Image 11",
      description: "Description de l'image 3",
    },
    {
      src: maisonCremeProfil,
      alt: "maison Creme Profil",
      title: "Image 12",
      description: "Description de l'image 3",
    },
    {
      src: maisonBlancheFace,
      alt: "maison Blanche Face",
      title: "Image 13",
      description: "Description de l'image 3",
    },
    {
      src: maisonBlancheProfil,
      alt: "maison Blanche Profil",
      title: "Image 14",
      description: "Description de l'image 3",
    },
    {
      src: maisonGrisToit2,
      alt: "maison Gris toit 2",
      title: "Image 15",
      description: "Description de l'image 3",
    },
    {
      src: maisonGrisToit3,
      alt: "maison Gris toit 3",
      title: "Image 16",
      description: "Description de l'image 3",
    },
    {
      src: maisonGrisToit,
      alt: "maison Gris toit",
      title: "Image 17",
      description: "Description de l'image 3",
    },
    {
      src: maisonGrisFinie,
      alt: "maison Gris Finie",
      title: "Image 18",
      description: "Description de l'image 3",
    },
    {
      src: maisonBlancheGris,
      alt: "maison Blanche Gris",
      title: "Image 19",
      description: "Description de l'image 3",
    },
    // Ajoutez plus d'images si nécessaire
  ];
  return (
    <BrowserRouter>
      <div className="container">
        <Navbar />
        <About />
        <Services />
        <ImageGallery images={images} />
        <ContactForm />
      </div>
      <GoogleMapsAddress />
      <Footer />
    </BrowserRouter>
  );
};

export default Home;
